import { useRecoilValue } from 'recoil';
import { addTextState, addTextStateLength } from '../states/addTextState';
import { Items } from '../types/items';
import classes from './AddBlock.module.scss';

export const AddBlock = () => {
  const addText = useRecoilValue(addTextState);
  const addTextLength = useRecoilValue(addTextStateLength);
  return (
    <div className={classes.block}>
      <div className={classes.length}>{addTextLength}個のタスクがあります</div>
      <ul className={classes.list}>
        {addText.map((item: Items) => (
          <li key={item.id} className={classes.item}>
            {item.text}
          </li>
        ))}
      </ul>
    </div>
  );
};
